import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import { redirectTo } from '../functions/redirectTo';
import useAxios from './useAxios';

export default function useCheckForSession(setIsCheckingSession: Dispatch<SetStateAction<boolean>>) {
    const axios = useAxios();
    const history = useHistory();
    const ref = useRef(false);

    useEffect(() => {
        // check for session, redirect if not found
        if (ref.current) {
            return;
        }
        checkForActiveSession();

        async function checkForActiveSession() {
            const sessionResponse = await axios.call('GET', '/api/sls/session/info');
            if (sessionResponse?.status !== 200) {
                redirectTo('/sso/signout');
                return;
            }
            setIsCheckingSession(false);
        }
        ref.current = true;
    }, [axios, history, setIsCheckingSession]);
}